export const DATA_COMPONENT_ATTRIBUTE = 'data-component';